export default __webpack_public_path__ + "static/media/gloves.4797847c.png";